import React from 'react';
import Modal from 'react-bootstrap/Modal';
import CheckIcon from 'assets/images/ambassador/check-circle.svg';
import SparkleIcon from 'assets/images/ambassador/sparkle-large.svg';
import WhatsappIcon from 'assets/images/ambassador/whatsapp.svg';
import { track } from 'services/tracking';
import PoppinsFont from 'styles/poppins_font';
import { Container } from './styles';

interface AmbassadorWelcomeModalProps {
  show: boolean;
  communityUrl: string | null;
  onClose: () => void;
}

const AmbassadorWelcomeModal: React.FC<AmbassadorWelcomeModalProps> = ({
  show,
  communityUrl,
  onClose,
}) => {
  const handleCommunityClick = () => {
    track('embaixador.acessou_comunidade');
    onClose();
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      size="lg"
      contentClassName="bg-transparent border-0"
      aria-labelledby="ambassador-welcome-title"
    >
      <PoppinsFont />
      <Container>
        <img className="welcome-check" src={CheckIcon} alt="" />

        <h2 id="ambassador-welcome-title" className="welcome-title">
          <img src={SparkleIcon} alt="" />
          Bem-vindo(a) ao time de Embaixadores
          <img className="sparkle-mirrored" src={SparkleIcon} alt="" />
        </h2>
        <p className="welcome-subtitle">sua participação foi confirmada!</p>
        <p className="welcome-text">
          Entre na comunidade exclusiva para receber orientações, materiais de apoio e avisos sobre
          as próximas ferramentas disponíveis para teste.
        </p>

        {communityUrl ? (
          <a
            className="welcome-button"
            href={communityUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleCommunityClick}
          >
            <img src={WhatsappIcon} alt="" />
            Acessar comunidade
          </a>
        ) : (
          <button type="button" className="welcome-button" onClick={onClose}>
            Continuar
          </button>
        )}
      </Container>
    </Modal>
  );
};

export default AmbassadorWelcomeModal;
